import { React, useState, useEffect, useContext, useMemo, useRef } from "react";
import { AppContext } from '../../../../AppStore';
import styled from "styled-components";
import { DataGrid } from '@mui/x-data-grid';
import GridNoRow from '../../../../common/GridNoRow';
import axios from "axios";
import Swal from "sweetalert2";
import Moment from 'moment';
import Button from "@mui/material/Button";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import "moment/locale/ko";
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { useNavigate, useLocation } from "react-router-dom";
import PCModal from '../../../../modal/PC/PCModal';

const MachineInspect = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const appStore = useContext(AppContext);
    const [MenuID, setMenuID] = useState(0);
    const [MenuName, setMenuName] = useState('');
    const [MenuUpdateExistYN, setMenuUpdateExistYN] = useState('N');
    const [MenuDeleteExistYN, setMenuDeleteExistYN] = useState('N');
    const [MenuUpdateYN, setMenuUpdateYN] = useState('N');
    const [MenuDeleteYN, setMenuDeleteYN] = useState('N');
    const [tabID, setTabID] = useState('');
    const [machineOption, setMachineOption] = useState([]);
    const [inspectTab, setInspectTab] = useState('table'); // 'table' | 'issue'
    const [dataRows, setDataRows] = useState([]);
    const [dataColumns, setDataColumns] = useState([]);
    const [issueRows, setIssueRows] = useState([]);
    const [issueColumns, setIssueColumns] = useState([]);
    const [baseMonth, setBaseMonth] = useState(Moment().format('YYYY-MM'));
    const [todayModalOpen, setTodayModalOpen] = useState(false);
    const [dirtyWeeks, setDirtyWeeks] = useState({});
    const [dirtyDays, setDirtyDays] = useState({});
    const [dirtyMonths, setDirtyMonths] = useState({});
    const dirtyWeeksRef = useRef({});
    const dirtyDaysRef = useRef({});
    const dirtyMonthsRef = useRef({});
    const [dataColumnVisibilityModel, setDataColumnVisibilityModel] = useState({
        id: false,
        machine_id: false,
        inspect_id: false,
        check_user_id: false,
        check_datetime: true,
        inspect_text: true,
        status: true,
    });
    const [issueColumnVisibilityModel, setIssueColumnVisibilityModel] = useState({
        id: false,
        machine_id: false,
        issue_id: false,
        issue_datetime: true,
        issue_text: true,
        cause_text: true,
        action_text: true,
        issue_user_name: true,
        cause_user_name: true,
        action_user_name: true,
    });
    const [editingIssueId, setEditingIssueId] = useState('');

    useEffect(() => {
        const accessList = JSON.parse(localStorage.getItem("nav"));
        
        if (Array.isArray(accessList) && accessList.filter(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).length > 0) {
            setMenuID(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_id);
            setMenuName(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_name);
            setMenuUpdateExistYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_exist_yn);
            setMenuDeleteExistYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_delete_exist_yn);
            setMenuUpdateYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_yn);
            setMenuDeleteYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_delete_yn);
        }else{
            Swal.fire({
                title: '<p style="color:red">접근 권한 오류</p>',
                text: '화면에 접근 권한이 없습니다.',
                confirmButtonText: '확인',
                confirmButtonColor: '#7066e0',
                timer:5000,
                timerProgressBar: true
            }).then((value) => {
                const main = localStorage.getItem("main") || "/p";
                return navigate(main, { replace: true });
            });
        }
    }, []);

    useEffect(() => {
        if (machineOption.length > 0) {
            const first = machineOption[0];
            setTabID(String(first.value));
        } else {
            setTabID('');
        }
    }, [machineOption]);

    useEffect(() => {
        handleView(undefined, todayModalOpen);
    }, [tabID, todayModalOpen]);

    useEffect(() => {
        // 아래의 변수가 변경되면 실행된다. -> 권한체크가 되면 MenuID가 변경되므로, 권한체크 후 Grid 설정.
        if(String(MenuID) !== String(0) && MenuID != null){
            handleSetting();
            axios.get('/api/SelectCommon/MachineList')
            .then((response) => {
                const optionArray = response.data.map((item, index) => 
                    ({ value: item.machine_id, label: item.machine_name })
                );
                setMachineOption([ ...new Set((optionArray).map(JSON.stringify)) ].map(JSON.parse));
            })
            .catch((error) => {
                console.log(error);
            });
        }
    }, [MenuID])

    const buildDayColumns = (monthString) => {
        const days = Moment(monthString, 'YYYY-MM', true).isValid()
            ? Moment(monthString, 'YYYY-MM').daysInMonth()
            : Moment().daysInMonth();
        return Array.from({ length: days }, (_, i) => ({
            field: `day${i + 1}`,
            headerName: String(i + 1),
            width: 42,
            headerAlign: 'center',
            align: 'center',
            type: 'singleSelect',
            valueOptions: ['O', '△', 'X'],
            editable: true
        }));
    };

    const normalizeCycleType = (value) => {
        const ct = String(value ?? '').trim().toUpperCase();
        return ct === 'W' || ct === 'M' ? ct : 'D';
    };

    const buildWeekRanges = (monthString) => {
        const m = Moment(monthString, 'YYYY-MM', true);
        const base = m.isValid() ? m : Moment();
        const days = base.daysInMonth();
        const ranges = [];
        let start = 1;
        while (start <= days) {
            const dow = base.clone().date(start).isoWeekday(); // 1=월 ... 7=일
            const span = Math.min(days - start + 1, 8 - dow);
            ranges.push({ start, span });
            start += span;
        }
        return ranges;
    };

    const handleSetting = (monthString) => {
        const dayCols = buildDayColumns(monthString ?? baseMonth);
        setDataColumns([
            { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
            { field: 'inspect_id', headerName: 'inspect_id', width: 0, headerAlign: 'center' },
            { field: 'cycle_type', headerName: '주기', width: 70, headerAlign: 'center', align:'center' },
            { field: 'inspect_text', headerName: '점검항목', flex: 1.5, minWidth: 280, headerAlign: 'center', align:'left' },
            ...dayCols
        ]);

        setIssueColumns([
            { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
            { field: 'machine_id', headerName: 'machine_id', width: 0, headerAlign: 'center' },
            { field: 'issue_id', headerName: 'issue_id', width: 0, headerAlign: 'center' },
            { field: 'issue_datetime', headerName: '이슈일시', width: 170, headerAlign: 'center', align:'center' },
            { field: 'issue_text', headerName: '이슈내용', flex: 1, minWidth: 220, headerAlign: 'center', align:'left' },
            { field: 'issue_user_name', headerName: '이슈자', width: 120, headerAlign: 'center', align:'center' },
            { field: 'cause_datetime', headerName: '원인일시', width: 170, headerAlign: 'center', align:'center' },
            { field: 'cause_text', headerName: '원인내용', flex: 1, minWidth: 220, headerAlign: 'center', align:'left' },
            { field: 'cause_user_name', headerName: '원인자', width: 120, headerAlign: 'center', align:'center' },
            { field: 'action_datetime', headerName: '조치일시', width: 170, headerAlign: 'center', align:'center' },
            { field: 'action_text', headerName: '조치내용', flex: 1, minWidth: 220, headerAlign: 'center', align:'left' },
            { field: 'action_user_name', headerName: '조치자', width: 120, headerAlign: 'center', align:'center' },
        ]);
    }

    const buildPivotRows = (raw, monthString) => {
        const m = Moment(monthString, 'YYYY-MM', true);
        const base = m.isValid() ? m : Moment();
        const days = base.daysInMonth();
        const monthStart = base.clone().startOf('month');
        const monthEnd = base.clone().endOf('month');
        const map = new Map();

        raw.forEach(r => {
            const key = r.inspect_id || r.inspect_text;
            if (!map.has(key)) {
                map.set(key, {
                    id: `p-${key}`,
                    inspect_id: r.inspect_id ?? 0,
                    cycle_type: normalizeCycleType(r.cycle_type),
                    inspect_text: r.inspect_text ?? '',
                    statusMap: {},
                    checkDatetimeMap: {}
                });
            }

            const start = Moment(r.start_date, 'YYYY-MM-DD', true);
            const end = Moment(r.end_date, 'YYYY-MM-DD', true);
            if (!start.isValid() || !end.isValid()) {
                return;
            }
            if (start.isAfter(monthEnd, 'day') || end.isBefore(monthStart, 'day')) {
                return;
            }

            const rangeStart = start.isBefore(monthStart, 'day') ? monthStart.clone() : start.clone();
            const rangeEnd = end.isAfter(monthEnd, 'day') ? monthEnd.clone() : end.clone();
            const row = map.get(key);
            for (let d = rangeStart.date(); d <= rangeEnd.date(); d++) {
                row.statusMap[d] = r.status || '';
                if (r.check_datetime) {
                    row.checkDatetimeMap[d] = r.check_datetime;
                }
            }
        });

        return Array.from(map.values()).map(row => {
            const dayObj = {};
            const checkObj = {};
            for (let d = 1; d <= days; d++) {
                dayObj[`day${d}`] = row.statusMap[d] || '';
                checkObj[`day${d}_dt`] = row.checkDatetimeMap[d] || '';
            }
            return { ...row, ...dayObj, ...checkObj };
        });
    };

    const handleView = (monthOverride, force) => {
        if(!tabID){
            return;
        }

        if (appStore.loading && !force) return;
        appStore.setLoading(true);
        setDirtyWeeks({});
        setDirtyDays({});
        setDirtyMonths({});
        dirtyWeeksRef.current = {};
        dirtyDaysRef.current = {};
        dirtyMonthsRef.current = {};
        const monthToUse = monthOverride ?? baseMonth;

        axios.get('/api/p/MachineInspect/DataList',
            {
            params : {
                machine_id : tabID,
                base_month : monthToUse
            }
          },
          { withCredentials: true }
        )
        .then((response) => {
            const array = (response.data || []).map((item, index) => ({
                id: `${item.machine_id || tabID}-${item.inspect_id || index}-${item.start_date || item.end_date || index}`,
                machine_id: item.machine_id ?? tabID,
                inspect_id: item.inspect_id ?? 0,
                inspect_text: item.inspect_text ?? '',
                cycle_type: normalizeCycleType(item.cycle_type),
                start_date: item.start_date ?? '',
                end_date: item.end_date ?? '',
                check_datetime: item.check_datetime ? Moment(item.check_datetime).format('YYYY-MM-DD HH:mm:ss') : '',
                check_user_id: item.check_user_id ?? 0,
                check_user_name: item.check_user_name ?? '',
                status: item.status ?? ''
            }));
            setDataRows(buildPivotRows(array, monthToUse));
        })
        .catch((error) => {
            setDataRows(buildPivotRows([], monthToUse));
            appStore.capture();
        });

        axios.get('/api/p/MachineInspect/IssueList',
            {
            params : {
                machine_id : tabID,
                base_month : baseMonth
            }
          },
          { withCredentials: true }
        )
        .then((response) => {
            const array = (response.data || []).map((item, index) => ({
                id: `${item.machine_id || tabID}-${item.issue_id || index}`,
                machine_id: item.machine_id ?? tabID,
                issue_id: item.issue_id ?? 0,
                issue_datetime: item.issue_datetime ? Moment(item.issue_datetime).format('YYYY-MM-DD HH:mm:ss') : '',
                issue_text: item.issue_text ?? '',
                issue_user_id: item.issue_user_id ?? 0,
                issue_user_name: item.issue_user_name ?? '',
                cause_datetime: item.cause_datetime ? Moment(item.cause_datetime).format('YYYY-MM-DD HH:mm:ss') : '',
                cause_text: item.cause_text ?? '',
                cause_user_id: item.cause_user_id ?? 0,
                cause_user_name: item.cause_user_name ?? '',
                action_datetime: item.action_datetime ? Moment(item.action_datetime).format('YYYY-MM-DD HH:mm:ss') : '',
                action_text: item.action_text ?? '',
                action_user_id: item.action_user_id ?? 0,
                action_user_name: item.action_user_name ?? '',
                delete_yn: item.delete_yn ?? 'N',
            }));
            setIssueRows(array);
        })
        .catch((error) => {
            setIssueRows([]);
            appStore.capture();
        })
        .finally(() => {
            appStore.setLoading(false);
        });
    };

    const handleTabID = (event, newTabID) => {
        setTabID(String(newTabID));
    };

    const handleMonthChange = (e) => {
        const val = e.target.value;
        setBaseMonth(val);
        handleSetting(val); // 재생성
        handleView(val);
    };
    const handleInspectTab = (e, val) => {
        setInspectTab(val);
    };
    const toggleInspectTab = () => {
        setInspectTab((prev) => (prev === 'table' ? 'issue' : 'table'));
    };

    const formatDate = (v) => {
        const m = Moment(v);
        return m.isValid() ? m.format('YYYY-MM-DD') : '';
    };

    const formatDateTime = (v) => {
        const m = Moment(v);
        return m.isValid() ? m.format('YYYY-MM-DD HH:mm:ss') : '';
    };

    const todayDate = useMemo(() => Moment().format('YYYY-MM-DD'), []);

    const todayItems = useMemo(() => {
        const base = Moment(baseMonth, 'YYYY-MM', true);
        const today = Moment(todayDate, 'YYYY-MM-DD', true);
        if (!base.isValid() || !today.isValid()) {
            return [];
        }
        if (base.format('YYYY-MM') !== today.format('YYYY-MM')) {
            return [];
        }
        const days = base.daysInMonth();
        const day = today.date();
        const weekRanges = buildWeekRanges(baseMonth);
        const week = weekRanges.find(r => day >= r.start && day < r.start + r.span);
            return dataRows.map((row) => {
                const ct = normalizeCycleType(row.cycle_type);
                if (ct === 'D') {
                    return {
                        inspect_id: row.inspect_id,
                        inspect_text: row.inspect_text,
                        cycle_type: ct,
                        value: row[`day${day}`] || '',
                        day,
                        start: day,
                        end: day
                    };
                }
                if (ct === 'W' && week) {
                    let value = '';
                    for (let d = week.start; d < week.start + week.span; d++) {
                        const v = row[`day${d}`];
                        if (v) {
                            value = v;
                            break;
                        }
                    }
                    return {
                        inspect_id: row.inspect_id,
                        inspect_text: row.inspect_text,
                        cycle_type: ct,
                        value,
                        day,
                        start: week.start,
                        end: week.start + week.span - 1
                    };
                }
                if (ct === 'M') {
                    let value = '';
                    for (let d = 1; d <= days; d++) {
                        const v = row[`day${d}`];
                        if (v) {
                            value = v;
                            break;
                        }
                    }
                    return {
                        inspect_id: row.inspect_id,
                        inspect_text: row.inspect_text,
                        cycle_type: ct,
                        value,
                        day,
                        start: 1,
                        end: days
                    };
                }
                return null;
        }).filter(Boolean);
    }, [baseMonth, dataRows, todayDate]);

    const handleOpenTodayModal = () => {
        const todayMonth = Moment().format('YYYY-MM');
        setBaseMonth(todayMonth);
        handleSetting(todayMonth);
        handleView(todayMonth, true);
        setTodayModalOpen(true);
    };

    const handleCloseTodayModal = () => {
        setTodayModalOpen(false);
    };

    const updateTodayValue = (item, value) => {
        const key = String(item.inspect_id);
        if (item.cycle_type === 'D') {
            const dayKey = String(item.day);
            const current = dirtyDaysRef.current[key] || {};
            dirtyDaysRef.current = {
                ...dirtyDaysRef.current,
                [key]: { ...current, [dayKey]: true }
            };
            setDirtyDays(dirtyDaysRef.current);
            setDataRows(prev => prev.map(r => {
                if (r.inspect_id !== item.inspect_id) return r;
                return { ...r, [`day${item.day}`]: value };
            }));
            return;
        }
        if (item.cycle_type === 'W') {
            const current = dirtyWeeksRef.current[key] || {};
            dirtyWeeksRef.current = {
                ...dirtyWeeksRef.current,
                [key]: { ...current, [String(item.start)]: true }
            };
            setDirtyWeeks(dirtyWeeksRef.current);
            setDataRows(prev => prev.map(r => {
                if (r.inspect_id !== item.inspect_id) return r;
                const updated = { ...r };
                for (let d = item.start; d <= item.end; d++) {
                    updated[`day${d}`] = value;
                }
                return updated;
            }));
            return;
        }
        if (item.cycle_type === 'M') {
            dirtyMonthsRef.current = {
                ...dirtyMonthsRef.current,
                [key]: true
            };
            setDirtyMonths(dirtyMonthsRef.current);
            setDataRows(prev => prev.map(r => {
                if (r.inspect_id !== item.inspect_id) return r;
                const updated = { ...r };
                const days = Moment(baseMonth, 'YYYY-MM', true).daysInMonth();
                for (let d = 1; d <= days; d++) {
                    updated[`day${d}`] = value;
                }
                return updated;
            }));
        }
    };

    const handleTodaySave = () => {
        const rows = [];
        const todayMonth = Moment().format('YYYY-MM');
        const days = Moment(todayMonth, 'YYYY-MM', true).daysInMonth();
        const pad = (n) => String(n).padStart(2, '0');

        todayItems.forEach((item) => {
            const startDate = `${todayMonth}-${pad(item.start)}`;
            const endDate = `${todayMonth}-${pad(item.end)}`;
            const status = item.value || '';
            rows.push({
                machine_id: tabID,
                inspect_id: item.inspect_id,
                start_date: startDate,
                end_date: endDate,
                status,
                delete_yn: status ? 'N' : 'Y'
            });
        });

        console.log('MachineInspect today save rows', {
            machine_id: tabID,
            base_month: todayMonth,
            rows
        });

        if (appStore.loading) return;
        appStore.setLoading(true);
        axios.post('/api/p/MachineInspect/DataSave', {
            machine_id: tabID,
            base_month: todayMonth,
            rows
        }, { withCredentials: true })
        .then(() => {
            handleView(todayMonth);
            Swal.fire({
                title: '저장 완료',
                text: '오늘 설비 점검 내용이 저장되었습니다.',
                confirmButtonText: '확인',
            });
            setTodayModalOpen(false);
        })
        .catch((error) => {
            console.log(error);
            appStore.capture();
            Swal.fire({
                title: '저장 실패',
                text: '저장 중 오류가 발생했습니다. 관리자에게 문의해주세요.',
                confirmButtonText: '확인',
            });
        })
        .finally(() => {
            appStore.setLoading(false);
        });
    };

    const buildInspectSaveRows = () => {
        const m = Moment(baseMonth, 'YYYY-MM', true);
        const base = m.isValid() ? m : Moment();
        const days = base.daysInMonth();
        const weekRanges = buildWeekRanges(baseMonth);
        const rows = [];
        const pad = (n) => String(n).padStart(2, '0');

        dataRows.forEach((row) => {
            const ct = normalizeCycleType(row.cycle_type);
            if (ct === 'D') {
                const dayDirty = dirtyDaysRef.current[String(row.inspect_id)] || {};
                for (let d = 1; d <= days; d++) {
                    if (!dayDirty[String(d)]) {
                        continue;
                    }
                    const status = row[`day${d}`] || '';
                    const date = `${baseMonth}-${pad(d)}`;
                    rows.push({
                        machine_id: tabID,
                        inspect_id: row.inspect_id,
                        start_date: date,
                        end_date: date,
                        status,
                        delete_yn: status ? 'N' : 'Y'
                    });
                }
                return;
            }

            if (ct === 'W') {
                const weekDirty = dirtyWeeksRef.current[String(row.inspect_id)] || {};
                weekRanges.forEach((range) => {
                    if (!weekDirty[String(range.start)]) {
                        return;
                    }
                    let status = '';
                    let foundDay = null;
                    for (let d = range.start; d < range.start + range.span; d++) {
                        const v = row[`day${d}`];
                        if (v) {
                            status = v;
                            foundDay = d;
                            break;
                        }
                    }
                    const startDate = `${baseMonth}-${pad(range.start)}`;
                    const endDate = `${baseMonth}-${pad(range.start + range.span - 1)}`;
                    if (!status) {
                        rows.push({
                            machine_id: tabID,
                            inspect_id: row.inspect_id,
                            start_date: startDate,
                            end_date: endDate,
                            status: '',
                            delete_yn: 'Y'
                        });
                        return;
                    }
                    console.log('MachineInspect weekly save', {
                        inspect_id: row.inspect_id,
                        start_date: startDate,
                        end_date: endDate,
                        status,
                        found_day: foundDay
                    });
                    rows.push({
                        machine_id: tabID,
                        inspect_id: row.inspect_id,
                        start_date: startDate,
                        end_date: endDate,
                        status,
                        delete_yn: 'N'
                    });
                });
                return;
            }

            if (ct === 'M') {
                const monthDirty = dirtyMonthsRef.current[String(row.inspect_id)];
                if (!monthDirty) {
                    return;
                }
                let status = '';
                for (let d = 1; d <= days; d++) {
                    const v = row[`day${d}`];
                    if (v) {
                        status = v;
                        break;
                    }
                }
                if (!status) {
                    rows.push({
                        machine_id: tabID,
                        inspect_id: row.inspect_id,
                        start_date: `${baseMonth}-01`,
                        end_date: `${baseMonth}-${pad(days)}`,
                        status: '',
                        delete_yn: 'Y'
                    });
                    return;
                }
                rows.push({
                    machine_id: tabID,
                    inspect_id: row.inspect_id,
                    start_date: `${baseMonth}-01`,
                    end_date: `${baseMonth}-${pad(days)}`,
                    status,
                    delete_yn: 'N'
                });
            }
        });

        return rows;
    };

    const handleAddIssueRow = () => {
        const newId = `new-${Date.now()}`;
        const newRow = {
            id: newId,
            machine_id: tabID,
            issue_id: 0,
            issue_datetime: '',
            issue_text: '',
            issue_user_name: '',
            cause_text: '',
            cause_datetime: '',
            cause_user_name: '',
            action_text: '',
            action_datetime: '',
            action_user_name: '',
            delete_yn: 'N',
        };
        setIssueRows((prev) => [newRow, ...prev]);
        setEditingIssueId(newId);
    };
    const updateIssueRowField = (rowId, field, value) => {
        setIssueRows((prev) =>
            prev.map((row) => (row.id === rowId ? { ...row, [field]: value } : row))
        );
    };
    const handleIssueDateChange = (rowId, field, value) => {
        const formatted = value ? Moment(value, 'YYYY-MM-DD', true).format('YYYY-MM-DD 00:00:00') : '';
        updateIssueRowField(rowId, field, formatted);
    };
    const toggleIssueEdit = (rowId) => {
        setEditingIssueId((prev) => (prev === rowId ? '' : rowId));
    };
    const toggleIssueDelete = (rowId) => {
        const target = issueRows.find(r => r.id === rowId);
        if (!target) return;

        const doRemoveLocal = () => {
            setIssueRows(prev => prev.filter(r => r.id !== rowId));
        };

        // 신규(아직 저장 안 됨)는 바로 제거
        if (!target.issue_id || String(target.issue_id) === '0' || String(target.id).startsWith('new-')) {
            doRemoveLocal();
            return;
        }

        Swal.fire({
            title: '문제발생 삭제',
            html: '문제발생 "<b>' + (target.issue_text || '') + '</b>"을(를) <span style="color:red; font-weight:bold;">삭제</span> 하시겠습니까?<br/>삭제하시면 복구 할 수 없습니다.',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            confirmButtonText: '삭제',
            cancelButtonText: '닫기'
        }).then((result) => {
            if (!result.isConfirmed) {
                return;
            }
            appStore.setLoading(true);
            axios.post('/api/p/MachineInspect/IssueSave', [{
                issue_id: target.issue_id,
                machine_id: target.machine_id || tabID,
                delete_yn: 'Y'
            }], { withCredentials: true })
            .then(() => {
                Swal.fire({
                    title: '삭제 완료',
                    text: '문제 발생 점검 데이터가 정상적으로 삭제되었습니다.',
                    confirmButtonText: '확인',
                    timer: 3000,
                    timerProgressBar: true
                }).then(() => {
                    doRemoveLocal();
                });
            })
            .catch((error) => {
                console.log(error);
                appStore.capture();
                Swal.fire({ title: '삭제 실패', text: '삭제 중 오류가 발생했습니다.', icon: 'error', confirmButtonText: '확인' });
            })
            .finally(() => {
                appStore.setLoading(false);
            });
        });
    };
    const handleSave = () => {
        let msg = '';

        if (inspectTab === 'table') {
            const rows = buildInspectSaveRows();
            console.log('MachineInspect save rows', {
                machine_id: tabID,
                base_month: baseMonth,
                rows
            });
            if (appStore.loading) return;
            appStore.setLoading(true);
            axios.post('/api/p/MachineInspect/DataSave', {
                machine_id: tabID,
                base_month: baseMonth,
                rows
            }, { withCredentials: true })
            .then(() => {
                handleView();
                Swal.fire({
                    title: '저장 완료',
                    text: '설비점검 정보가 정상적으로 저장되었습니다.',
                    confirmButtonText: '확인',
                });
            })
            .catch((error) => {
                console.log(error);
                appStore.capture();
                Swal.fire({
                    title: '저장 실패',
                    text: '저장 중 오류가 발생했습니다. 관리자에게 문의해주세요.',
                    confirmButtonText: '확인',
                });
            })
            .finally(() => {
                appStore.setLoading(false);
            });
            return;
        }

        if (inspectTab !== 'issue') {
            msg = '문제 발생 점검 탭에서 저장할 수 있습니다.';
        }

        if (msg === '') {
            for (let i = 0; i < issueRows.length; i++) {
                const r = issueRows[i];
                if (r.delete_yn === 'Y') continue;
                const text = (r.issue_text || '').trim();
                const dt = (r.issue_datetime || '').trim();

                if (!text) {
                    msg = '문제발생은 필수 입력입니다.';
                    break;
                }
                if (!dt) {
                    msg = '점검일은 필수 입력입니다.';
                    break;
                }
            }
        }

        if (msg !== '') {
            Swal.fire({
                title: '<p style="color:red">저장 오류</p>',
                html: msg,
                confirmButtonText: '확인'
            });
            return;
        }

        if (appStore.loading) return;
        appStore.setLoading(true);
        axios.post('/api/p/MachineInspect/IssueSave', issueRows, { withCredentials: true })
        .then(() => {
            handleView();
            Swal.fire({
                title: '저장 완료',
                text: '문제 발생 점검 데이터가 저장되었습니다.',
                confirmButtonText: '확인',
            });
        })
        .catch((error) => {
            console.log(error);
            appStore.capture();
            Swal.fire({
                title: '저장 실패',
                text: '저장 중 오류가 발생했습니다. 관리자에게 문의해주세요.',
                confirmButtonText: '확인',
            });
        })
        .finally(() => {
            appStore.setLoading(false);
        });
    };
    
    return (
        <div style={ { width:'100%', display: String(MenuID) === String(0) ? 'hidden' : 'block' } }>
            <div className="menubox" style={ { height: '185px', boxShadow: 'none' , paddingRight: '0px' } }>
                <div className="menu-action" style={ { height: '55px',paddingRight: '0px' } }>
                    <div className="menu-title">{ MenuName }</div>
                </div>
                <TabContext value={tabID || (machineOption[0] ? String(machineOption[0].value) : '')}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <TabList onChange={handleTabID} style={{ paddingLeft: '20px'}}>
                            {machineOption.length > 0 && machineOption.map((item, index) => (
                                <Tab key={index} label={item.label} value={String(item.value)} />
                            ))}
                        </TabList>
                    </Box>
                </TabContext>
                <div className="menu-keyword" style={{ paddingTop: "5px", paddingRight: '0px' }}>
                    <div className="menu-keyword-sub">
                        <div
                        className="menu-keyword-sub-title"
                        style={{ width: "100px", fontWeight: "bold" }}
                        >
                        기준년월
                        </div>
                        <div
                        className="menu-keyword-sub-keyword"
                        style={{ maxWidth: "200px" }}
                        >
                        <input
                            type="month"
                            value={baseMonth}
                            name="baseMonth"
                            autoComplete="off"
                            onChange={handleMonthChange}
                        />
                        </div>
                        <div style={{ display:'flex', alignItems:'center', gap:10, paddingLeft:20, paddingTop:9, fontSize:18, color:'#374151' }}>
                            <span style={{ fontWeight: inspectTab === 'table' ? 700 : 400, lineHeight:1 }}>설비 점검</span>
                            <div
                                onClick={toggleInspectTab}
                                style={{
                                    width: 46,
                                    height: 24,
                                    borderRadius: 12,
                                    background: inspectTab === 'table' ? '#4b90f6' : '#f97316',
                                    position: 'relative',
                                    cursor: 'pointer',
                                    transition: 'background 0.2s ease',
                                    boxShadow: 'inset 0 1px 2px rgba(0,0,0,0.12)',
                                }}
                            >
                                <div
                                    style={{
                                        position: 'absolute',
                                        top: 3,
                                        left: inspectTab === 'table' ? 3 : 23,
                                        width: 18,
                                        height: 18,
                                        borderRadius: '50%',
                                        background: '#fff',
                                        transition: 'left 0.2s ease, background 0.2s ease',
                                        boxShadow: '0 1px 2px rgba(0,0,0,0.15)',
                                    }}
                                />
                            </div>
                            <span style={{ fontWeight: inspectTab === 'issue' ? 700 : 400, lineHeight:1 }}>문제 발생 점검</span>
                        </div>
                    </div>
                    <div className="menu-button" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        {inspectTab === 'issue' && (
                            <Button
                                onClick={ handleAddIssueRow }
                                className="btn-p btn-u"
                                sx={{  
                                    m: 1, 
                                    fontSize: 15, 
                                    color: "white", 
                                    borderColor: "#e67d06ff", 
                                    backgroundColor: "#e67d06ff",
                                    ":hover": { boxShadow: "2px 2px 2px #e67d06ff" , backgroundColor: "#e67d06ff", borderColor: "#e67d06ff"}
                                }} 
                                variant="outlined">
                                추가
                            </Button>
                        )}
                        {inspectTab === 'table' && (
                            <Button
                                onClick={ handleOpenTodayModal }
                                className="btn-p btn-u"
                                sx={{
                                    m: 1,
                                    fontSize: 15,
                                    color: "white",
                                    borderColor: "#3b82f6",
                                    backgroundColor: "#3b82f6",
                                    ":hover": { boxShadow: "2px 2px 2px #3b82f6" , backgroundColor: "#3b82f6", borderColor: "#3b82f6"}
                                }}
                                variant="outlined">
                                오늘
                            </Button>
                        )}
                        <Button 
                            onClick={ handleSave }
                            className="btn-p btn-u"
                            sx={{  
                                m: 1, 
                                fontSize: 15, 
                                color: "white", 
                                borderColor: "#FF3636", 
                                backgroundColor: "#FF3636",
                                ":hover": { boxShadow: "2px 2px 2px #FF3636" , backgroundColor: "#FF3636", borderColor: "#FF3636"}
                            }} 
                            variant="outlined">
                            저장
                        </Button>
                    </div>
                </div>
            </div>
            <div className="grid" style={ { top: '187px', height: 'calc(100vh - 287px)', overflow: 'hidden' } }>
                <div style={ {  width: '100%', height:'100%', display:'flex', flexDirection:'column' } }>
                    <div style={{ width: '100%', height:'100%' }}>
                        <div className="grid_sub" style={ { width: '100%', height: '100%', fontSize: '17px', display: 'flex', flexDirection:'column' } }>
                            <div style={{ width: '100%', flex:'1 1 0', display: inspectTab === 'table' ? 'flex' : 'none', flexDirection:'column', overflow:'hidden' }}>
                                <div style={{ overflow:'auto', border:'1px solid #ddd', borderRadius:8, flex:1 }}>
                                    <table style={{ width:'100%', borderCollapse:'collapse', fontSize:14 }}>
                                        <thead>
                                            <tr>
                                                <th rowSpan={2} style={{ width:48, background:'#f9fafb', borderBottom:'1px solid #e5e7eb', borderRight:'1px solid #e5e7eb', fontSize:16, fontWeight:700 }}>주기</th>
                                                <th rowSpan={2} style={{ width:250, background:'#f9fafb', borderBottom:'1px solid #e5e7eb', borderRight:'1px solid #e5e7eb', fontSize:16, fontWeight:700 }}>점검항목</th>
                                                <th colSpan={Moment(baseMonth, 'YYYY-MM', true).daysInMonth()} style={{ background:'#f9fafb', borderBottom:'1px solid #e5e7eb', fontSize:16, fontWeight:700 }}>일자</th>
                                            </tr>
                                            <tr>
                                                {Array.from({length: Moment(baseMonth, 'YYYY-MM', true).daysInMonth()}, (_,i)=>(
                                                    <th key={`hd-${i+1}`} style={{ width:42, textAlign:'center', borderRight:'1px solid #eee', fontSize:16, fontWeight:700 }}>{i+1}</th>
                                                ))}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {(() => {
                                                const days = Moment(baseMonth, 'YYYY-MM', true).isValid()
                                                    ? Moment(baseMonth, 'YYYY-MM').daysInMonth()
                                                    : Moment().daysInMonth();
                                                const labelMap = { D:'일\n일\n점\n검', W:'주\n간\n점\n검', M:'월\n간\n점\n검' };
                                                const order = ['D','W','M'];
                                                const grouped = order
                                                    .map(ct => ({ ct, rows: dataRows.filter(r => r.cycle_type === ct) }))
                                                    .filter(g => g.rows.length > 0);
                                                const weekRanges = [];
                                                let startDay = 1;
                                                while(startDay <= days){
                                                    const m = Moment(`${baseMonth}-${String(startDay).padStart(2,'0')}`, 'YYYY-MM-DD');
                                                    const iso = m.isValid() ? m.isoWeekday() : 7; // 1=월 ... 7=일
                                                    const span = Math.min(days - startDay + 1, 8 - iso);
                                                    weekRanges.push({ start: startDay, span });
                                                    startDay += span;
                                                }
                                                const renderCycleCell = (ct, span) => (
                                                    <td rowSpan={span} style={{ textAlign:'center', whiteSpace:'pre-line', fontWeight:700, fontSize:16, background:'#f3f4f6', borderRight:'1px solid #e5e7eb', borderBottom:'1px solid #e5e7eb' }}>
                                                        {labelMap[ct] || ct}
                                                    </td>
                                                );
                                                const renderDailyCells = (row) => (
                                                    Array.from({length: days}, (_,i)=>{
                                                        const day = i+1;
                                                        const val = row[`day${day}`] || '';
                                                        const tooltip = row[`day${day}`] && row[`day${day}`] !== ''
                                                            ? `점검일시 : ${row[`day${day}_dt`] || ''}`
                                                            : '';
                                                        return (
                                                            <td key={`d-${row.id}-${day}`} style={{ textAlign:'center', borderBottom:'1px solid #f0f0f0', borderRight:'1px solid #f5f5f5', padding:'4px' }}>
                                                                <select
                                                                    value={val}
                                                                    title={tooltip}
                                                                    onChange={(e)=>{
                                                                        const value = e.target.value;
                                                                        const key = String(row.inspect_id);
                                                                        const current = dirtyDaysRef.current[key] || {};
                                                                    dirtyDaysRef.current = {
                                                                        ...dirtyDaysRef.current,
                                                                        [key]: { ...current, [String(day)]: true }
                                                                    };
                                                                    setDirtyDays(dirtyDaysRef.current);
                                                                    setDataRows(prev => prev.map(r=> r.id === row.id ? ({...r, [`day${day}`]: value}) : r));
                                                                }}
                                                                    style={{ width:'100%', border:'1px solid #d1d5db', borderRadius:4, padding:'2px 4px', textAlign:'center', textAlignLast:'center' }}
                                                                >
                                                                    <option value=""></option>
                                                                    <option value="O">O</option>
                                                                    <option value="T">△</option>
                                                                    <option value="X">X</option>
                                                                </select>
                                                            </td>
                                                        );
                                                    })
                                                );
                                                    const renderWeeklyCells = (row) => {
                                                        const tds = [];
                                                        weekRanges.forEach((range, idx)=>{
                                                            const { start, span } = range;
                                                            let foundDay = null;
                                                            const val = (()=> {
                                                                for(let d=start; d<start+span; d++){
                                                                    const v = row[`day${d}`];
                                                                    if(v) {
                                                                        foundDay = d;
                                                                        return v;
                                                                    }
                                                                }
                                                                return '';
                                                            })();
                                                            const tooltip = foundDay
                                                                ? `점검일시 : ${row[`day${foundDay}_dt`] || ''}`
                                                                : '';
                                                            tds.push(
                                                                <td key={`w-${row.id}-${idx}`} colSpan={span} style={{ textAlign:'center', borderBottom:'1px solid #f0f0f0', borderRight:'1px solid #f5f5f5', padding:'4px' }}>
                                                                    <select
                                                                        value={val}
                                                                        title={tooltip}
                                                                        onChange={(e)=>{
                                                                            const value = e.target.value;
                                                                            console.log('MachineInspect weekly select', {
                                                                                inspect_id: row.inspect_id,
                                                                                week_start: start,
                                                                            week_span: span,
                                                                            value
                                                                        });
                                                                        const key = String(row.inspect_id);
                                                                        const current = dirtyWeeksRef.current[key] || {};
                                                                        dirtyWeeksRef.current = {
                                                                            ...dirtyWeeksRef.current,
                                                                            [key]: { ...current, [String(start)]: true }
                                                                        };
                                                                        setDirtyWeeks(dirtyWeeksRef.current);
                                                                    setDataRows(prev => prev.map(r=>{
                                                                        if(r.id !== row.id) return r;
                                                                        const updated = {...r};
                                                                        for(let d=start; d<start+span; d++){
                                                                            updated[`day${d}`] = value;
                                                                            }
                                                                            return updated;
                                                                        }));
                                                                    }}
                                                                    style={{ width:'100%', border:'1px solid #d1d5db', borderRadius:4, padding:'2px 4px', textAlign:'center', textAlignLast:'center' }}
                                                                >
                                                                    <option value=""></option>
                                                                    <option value="O">O</option>
                                                                    <option value="T">△</option>
                                                                    <option value="X">X</option>
                                                                </select>
                                                            </td>
                                                        );
                                                    });
                                                    return tds;
                                                };
                                                    const renderMonthlyCells = (row) => {
                                                        let foundDay = null;
                                                        const val = (()=> {
                                                            for(let d=1; d<=days; d++){
                                                                const v = row[`day${d}`];
                                                                if(v) {
                                                                    foundDay = d;
                                                                    return v;
                                                                }
                                                            }
                                                            return '';
                                                        })();
                                                        const tooltip = foundDay
                                                            ? `점검일시 : ${row[`day${foundDay}_dt`] || ''}`
                                                            : '';
                                                        return (
                                                            <td colSpan={days} style={{ textAlign:'center', borderBottom:'1px solid #f0f0f0', borderRight:'1px solid #f5f5f5', padding:'4px' }}>
                                                                <select
                                                                    value={val}
                                                                    title={tooltip}
                                                                    onChange={(e)=>{
                                                                        const value = e.target.value;
                                                                        console.log('MachineInspect monthly select', {
                                                                            inspect_id: row.inspect_id,
                                                                            value
                                                                    });
                                                                    const key = String(row.inspect_id);
                                                                    dirtyMonthsRef.current = {
                                                                        ...dirtyMonthsRef.current,
                                                                        [key]: true
                                                                    };
                                                                    setDirtyMonths(dirtyMonthsRef.current);
                                                                    setDataRows(prev => prev.map(r=>{
                                                                        if(r.id !== row.id) return r;
                                                                        const updated = {...r};
                                                                        for(let d=1; d<=days; d++){
                                                                            updated[`day${d}`] = value;
                                                                        }
                                                                        return updated;
                                                                    }));
                                                                }}
                                                                style={{ width:'100%', border:'1px solid #d1d5db', borderRadius:4, padding:'2px 4px', textAlign:'center', textAlignLast:'center' }}
                                                            >
                                                                <option value=""></option>
                                                                <option value="O">O</option>
                                                                <option value="T">△</option>
                                                                <option value="X">X</option>
                                                            </select>
                                                        </td>
                                                    );
                                                };
                                                const rows = [];
                                                grouped.forEach(group => {
                                                    const span = group.rows.length;
                                                    group.rows.forEach((row, idx) => {
                                                        rows.push(
                                                            <tr key={row.id}>
                                                                {idx === 0 && renderCycleCell(group.ct, span)}
                                                                <td style={{ borderRight:'1px solid #e5e7eb', borderBottom:'1px solid #f0f0f0', padding:'6px 8px', minWidth:260 }}>{row.inspect_text}</td>
                                                                {group.ct === 'D' && renderDailyCells(row)}
                                                                {group.ct === 'W' && renderWeeklyCells(row)}
                                                                {group.ct === 'M' && renderMonthlyCells(row)}
                                                            </tr>
                                                        );
                                                    });
                                                });
                                                return rows;
                                            })()}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div style={{ width: '100%', flex:'1 1 0', display: inspectTab === 'issue' ? 'flex' : 'none', flexDirection:'column', overflow:'hidden' }}>
                                <div style={{ flex:1, border:'1px solid #ddd', borderRadius:8, overflow:'auto' }}>
                                    <table style={{ width:'100%', borderCollapse:'collapse', fontSize:14 }}>
                                        <thead>
                                            <tr>
                                                <th style={{ background:'#f9fafb', borderBottom:'1px solid #e5e7eb', borderRight:'1px solid #e5e7eb', width:70, fontSize:16, fontWeight:700 }}>삭제</th>
                                                <th style={{ background:'#f9fafb', borderBottom:'1px solid #e5e7eb', borderRight:'1px solid #e5e7eb', width:60, fontSize:16, fontWeight:700 }}>수정</th>
                                                <th style={{ background:'#f9fafb', borderBottom:'1px solid #e5e7eb', borderRight:'1px solid #e5e7eb', width:120, fontSize:16, fontWeight:700 }}>점검일</th>
                                                <th style={{ background:'#f9fafb', borderBottom:'1px solid #e5e7eb', borderRight:'1px solid #e5e7eb', minWidth:220, fontSize:16, fontWeight:700 }}>문제발생</th>
                                                <th style={{ background:'#f9fafb', borderBottom:'1px solid #e5e7eb', borderRight:'1px solid #e5e7eb', minWidth:200, fontSize:16, fontWeight:700 }}>원인</th>
                                                <th style={{ background:'#f9fafb', borderBottom:'1px solid #e5e7eb', borderRight:'1px solid #e5e7eb', minWidth:200, fontSize:16, fontWeight:700 }}>대책</th>
                                                <th style={{ background:'#f9fafb', borderBottom:'1px solid #e5e7eb', borderRight:'1px solid #e5e7eb', width:120, fontSize:16, fontWeight:700 }}>완료일</th>
                                                <th style={{ background:'#f9fafb', borderBottom:'1px solid #e5e7eb', borderRight:'1px solid #e5e7eb', width:110, fontSize:16, fontWeight:700 }}>담당자</th>
                                                <th style={{ background:'#f9fafb', borderBottom:'1px solid #e5e7eb', width:110, fontSize:16, fontWeight:700 }}>확인자</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {issueRows.length === 0 && (
                                                <tr>
                                                    <td colSpan={7} style={{ textAlign:'center', padding:'12px', color:'#6b7280' }}>데이터가 없습니다.</td>
                                                </tr>
                                            )}
                                            {issueRows.map((row) => (
                                                <tr key={row.id}>
                                                    <td style={{ textAlign:'center', borderBottom:'1px solid #f0f0f0', borderRight:'1px solid #f5f5f5', padding:'6px 8px' }}>
                                                        <Button
                                                            variant="text"
                                                            size="small"
                                                            onClick={() => toggleIssueDelete(row.id)}
                                                            sx={{ minWidth: 0, padding: '4px', color: row.delete_yn === 'Y' ? '#dc2626' : '#4b5563' }}
                                                        >
                                                            <DeleteOutlineIcon fontSize="small" />
                                                        </Button>
                                                    </td>
                                                    <td style={{ textAlign:'center', borderBottom:'1px solid #f0f0f0', borderRight:'1px solid #f5f5f5', padding:'6px 8px' }}>
                                                        <Button
                                                            variant="text"
                                                            size="small"
                                                            onClick={() => toggleIssueEdit(row.id)}
                                                            sx={{ minWidth: 0, padding: '4px', color: editingIssueId === row.id ? '#f97316' : '#4b5563' }}
                                                        >
                                                            <EditOutlinedIcon fontSize="small" />
                                                        </Button>
                                                    </td>
                                                    <td style={{ textAlign:'center', borderBottom:'1px solid #f0f0f0', borderRight:'1px solid #f5f5f5', padding:'6px 8px' }}>
                                                        {editingIssueId === row.id ? (
                                                            <input
                                                                type="date"
                                                                value={formatDate(row.issue_datetime)}
                                                                onChange={(e)=>handleIssueDateChange(row.id, 'issue_datetime', e.target.value)}
                                                                style={{ width:'100%', border:'1px solid #d1d5db', borderRadius:4, padding:'4px' }}
                                                            />
                                                        ) : (
                                                            formatDate(row.issue_datetime)
                                                        )}
                                                    </td>
                                                    <td style={{ borderBottom:'1px solid #f0f0f0', borderRight:'1px solid #f5f5f5', padding:'6px 8px' }}>
                                                        {editingIssueId === row.id ? (
                                                            <input
                                                                type="text"
                                                                value={row.issue_text || ''}
                                                                onChange={(e)=>updateIssueRowField(row.id, 'issue_text', e.target.value)}
                                                                style={{ width:'100%', border:'1px solid #d1d5db', borderRadius:4, padding:'4px' }}
                                                            />
                                                        ) : (
                                                            row.issue_text || ''
                                                        )}
                                                    </td>
                                                    <td style={{ borderBottom:'1px solid #f0f0f0', borderRight:'1px solid #f5f5f5', padding:'6px 8px' }}>
                                                        {editingIssueId === row.id ? (
                                                            <input
                                                                type="text"
                                                                value={row.cause_text || ''}
                                                                onChange={(e)=>updateIssueRowField(row.id, 'cause_text', e.target.value)}
                                                                style={{ width:'100%', border:'1px solid #d1d5db', borderRadius:4, padding:'4px' }}
                                                            />
                                                        ) : (
                                                            <span title={`원인자: ${row.cause_user_name || ''}\n원인일시: ${formatDateTime(row.cause_datetime)}`} style={{ display:'inline-flex', alignItems:'center', gap:4, cursor:'pointer' }}>
                                                                {row.cause_text || ''}
                                                                {(row.cause_user_name || row.cause_datetime) && <InfoOutlinedIcon fontSize="inherit" sx={{ fontSize: 16, color:'#6b7280' }} />}
                                                            </span>
                                                        )}
                                                    </td>
                                                    <td style={{ borderBottom:'1px solid #f0f0f0', borderRight:'1px solid #f5f5f5', padding:'6px 8px' }}>
                                                        {editingIssueId === row.id ? (
                                                            <input
                                                                type="text"
                                                                value={row.action_text || ''}
                                                                onChange={(e)=>updateIssueRowField(row.id, 'action_text', e.target.value)}
                                                                style={{ width:'100%', border:'1px solid #d1d5db', borderRadius:4, padding:'4px' }}
                                                            />
                                                        ) : (
                                                            <span style={{ display:'inline-flex', alignItems:'center', gap:4 }}>
                                                                {row.action_text || ''}
                                                            </span>
                                                        )}
                                                    </td>
                                                    <td style={{ textAlign:'center', borderBottom:'1px solid #f0f0f0', borderRight:'1px solid #f5f5f5', padding:'6px 8px' }}>
                                                        {editingIssueId === row.id ? (
                                                            <input
                                                                type="date"
                                                                value={formatDate(row.action_datetime)}
                                                                onChange={(e)=>handleIssueDateChange(row.id, 'action_datetime', e.target.value)}
                                                                style={{ width:'100%', border:'1px solid #d1d5db', borderRadius:4, padding:'4px' }}
                                                            />
                                                        ) : (
                                                            formatDate(row.action_datetime)
                                                        )}
                                                    </td>
                                                    <td style={{ textAlign:'center', borderBottom:'1px solid #f0f0f0', borderRight:'1px solid #f5f5f5', padding:'6px 8px' }}>
                                                        {row.issue_user_name || ''}
                                                    </td>
                                                    <td style={{ textAlign:'center', borderBottom:'1px solid #f0f0f0', padding:'6px 8px' }}>
                                                        {row.action_user_name || ''}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {todayModalOpen && (
                <PCModal onClose={handleCloseTodayModal} title={`오늘(${todayDate}) 점검 등록`}>
                    <div className="modal" style={{ height: 'auto', overflowY: 'auto' }}>
                        {machineOption.length > 0 && (
                            <TabContext value={tabID || (machineOption[0] ? String(machineOption[0].value) : '')}>
                                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                    <TabList onChange={handleTabID} style={{ paddingLeft: '20px' }}>
                                        {machineOption.map((item, index) => (
                                            <Tab key={`today-tab-${index}`} label={item.label} value={String(item.value)} />
                                        ))}
                                    </TabList>
                                </Box>
                            </TabContext>
                        )}
                        <div style={{ padding:'16px', maxHeight:'500px', overflow:'auto' }}>
                            {todayItems.length === 0 && (
                                <div style={{ color:'#6b7280' }}>
                                    기준년월이 오늘과 다르거나 표시할 항목이 없습니다.
                                </div>
                            )}
                            {todayItems.length > 0 && (
                                <table style={{ width:'100%', borderCollapse:'collapse', fontSize:14 }}>
                                    <thead>
                                        <tr>
                                            <th style={{ background:'#f9fafb', borderBottom:'1px solid #e5e7eb', borderRight:'1px solid #e5e7eb', width:80, fontWeight:700 }}>주기</th>
                                            <th style={{ background:'#f9fafb', borderBottom:'1px solid #e5e7eb', borderRight:'1px solid #e5e7eb', minWidth:260, fontWeight:700 }}>점검항목</th>
                                            <th style={{ background:'#f9fafb', borderBottom:'1px solid #e5e7eb', fontWeight:700 }}>결과</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {todayItems.map((item) => (
                                            <tr key={`today-${item.inspect_id}-${item.cycle_type}`}>
                                                <td style={{ textAlign:'center', borderBottom:'1px solid #f0f0f0', borderRight:'1px solid #f5f5f5', padding:'6px 8px' }}>
                                                    {item.cycle_type === 'D' ? '일일' : item.cycle_type === 'W' ? '주간' : '월간'}
                                                </td>
                                                <td style={{ borderBottom:'1px solid #f0f0f0', borderRight:'1px solid #f5f5f5', padding:'6px 8px' }}>
                                                    {item.inspect_text}
                                                </td>
                                                <td style={{ textAlign:'center', borderBottom:'1px solid #f0f0f0', padding:'6px 8px' }}>
                                                    <select
                                                        value={item.value || ''}
                                                        onChange={(e)=>updateTodayValue(item, e.target.value)}
                                                        style={{ width:'100%', border:'1px solid #d1d5db', borderRadius:4, padding:'2px 4px', textAlign:'center', textAlignLast:'center' }}
                                                    >
                                                        <option value=""></option>
                                                        <option value="O">O</option>
                                                        <option value="T">△</option>
                                                        <option value="X">X</option>
                                                    </select>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            )}
                        </div>
                        <table className="ModalTABLE">
                            <tbody>
                                <tr>
                                    <td className="ModalTD" colSpan={2}>
                                        <div className="modal_action">
                                            <div className="modal_button">
                                                <Button
                                                    onClick={handleCloseTodayModal}
                                                    className="btn-p"
                                                    sx={{
                                                        m: 1,
                                                        fontSize: 18,
                                                        color: "white",
                                                        borderColor: "#808080",
                                                        backgroundColor: "#808080",
                                                        ":hover": { boxShadow: "2px 2px 2px #808080" , backgroundColor: "#808080", borderColor: "#808080"}
                                                    }}
                                                    variant="outlined">
                                                    닫기
                                                </Button>
                                            </div>
                                            <div className="modal_button">
                                                <Button
                                                    onClick={handleTodaySave}
                                                    className="btn-p btn-u"
                                                    sx={{
                                                        m: 1,
                                                        fontSize: 18,
                                                        color: "white",
                                                        borderColor: "#FF3636",
                                                        backgroundColor: "#FF3636",
                                                        ":hover": { boxShadow: "2px 2px 2px #FF3636" , backgroundColor: "#FF3636", borderColor: "#FF3636"}
                                                    }}
                                                    variant="outlined">
                                                    저장
                                                </Button>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </PCModal>
            )}
        </div>
    )
}

const AppWrap = styled.div`
  text-align: center;
  margin: 50px auto;
`;
export default MachineInspect;
